import React from "react"

export function Close({
  fill = "white",
  h = 20,
  w = 20,
  className,
  onClick,
}: {
  fill?: string
  h?: number | string
  w?: number | string
  className?: string
  onClick?: () => void
}) {
  return (
    <svg
      onClick={onClick}
      width={w}
      height={h}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill={fill}
        d="M13.913 1.02948L7.99999 6.94248L2.08699 1.02948C1.94477 0.899339 1.75783 0.829086 1.5651 0.833356C1.37237 0.837627 1.18872 0.916091 1.05241 1.0524C0.916096 1.18872 0.837631 1.37236 0.833361 1.56509C0.829091 1.75782 0.899344 1.94476 1.02948 2.08698L6.93949 7.99998L1.02798 13.9115C0.955763 13.9803 0.89803 14.0629 0.858178 14.1543C0.818327 14.2458 0.797161 14.3443 0.795925 14.4441C0.79469 14.5438 0.81341 14.6428 0.850984 14.7352C0.888558 14.8277 0.944229 14.9116 1.01472 14.9822C1.08522 15.0528 1.16911 15.1086 1.26148 15.1463C1.35385 15.184 1.45282 15.2029 1.55258 15.2018C1.65234 15.2007 1.75087 15.1797 1.84239 15.1399C1.9339 15.1002 2.01656 15.0426 2.08549 14.9705L7.99999 9.05898L13.913 14.972C14.0552 15.1021 14.2422 15.1724 14.4349 15.1681C14.6276 15.1638 14.8113 15.0854 14.9476 14.9491C15.0839 14.8127 15.1624 14.6291 15.1666 14.4364C15.1709 14.2436 15.1006 14.0567 14.9705 13.9145L9.05749 8.00148L14.9705 2.08698C15.0427 2.01815 15.1005 1.93558 15.1403 1.84412C15.1802 1.75266 15.2013 1.65416 15.2026 1.5544C15.2038 1.45464 15.1851 1.35564 15.1475 1.26323C15.1099 1.17081 15.0543 1.08683 14.9838 1.01624C14.9133 0.945642 14.8294 0.889852 14.737 0.852147C14.6446 0.814442 14.5457 0.795582 14.4459 0.796676C14.3461 0.79777 14.2476 0.818796 14.1561 0.858518C14.0646 0.89824 13.9819 0.955856 13.913 1.02798V1.02948Z"
      />
    </svg>
  )
}
